module.exports = __webpack_public_path__ + "static/img/banner-bg.6173067.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/banner-bg.png
// module id = gzJj
// module chunks = 70